import { Button, Icon, Spinner } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useGroupActionConfig } from 'modules/Services/Network/subcomponents/AccountsList/hooks/useGroupActionConfig'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

export const DeleteButton = ({ action, id, login, icon, className = '', noLabel, ...rest }) => {
  const { t } = useTranslation(['services'])
  const [processing, setProcessing] = useState(false)
  const [getActionConfig, runGroupAction] = useGroupActionConfig()
  const groupActionConfig = getActionConfig(action, { name: login })
  const breakpoints = useBreakpoint()

  const handleClick = useCallback(() => {
    if (processing) {
      return
    }

    setProcessing(true)

    runGroupAction({
      groupActionConfig,
      ids: [id],
    })
  }, [setProcessing, id, groupActionConfig, processing, runGroupAction])

  return (
    <Button
      size={'s'}
      variant={'ghost'}
      link
      align={'left'}
      className={className}
      onClick={handleClick}
      startIcon={
        processing ? (
          <Spinner width={24} />
        ) : (
          <Icon
            name={icon}
            color={rest.iconColor ?? 'inherit'}
          />
        )
      }
      noLabel={noLabel ?? !breakpoints.xxl}
      {...rest}
    >
      {t(`services::account_list.extra_actions.${action}`)}
    </Button>
  )
}

DeleteButton.propTypes = {
  action: PropTypes.string,
  id: PropTypes.number,
  login: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  noLabel: PropTypes.bool,
}
